import { HoverCard, Portal } from '@chakra-ui/react';

import React, { useState } from 'react';

const Tooltip = React.forwardRef(function Tooltip(props, ref) {
  const {
    showArrow = true,
    children,
    disabled,
    portalled = true,
    content,
    contentProps,
    portalRef,
  } = props;

  if (disabled) return children;

  return (
    <HoverCard.Root size="sm">
      <HoverCard.Trigger asChild>{children}</HoverCard.Trigger>
      <Portal>
        <HoverCard.Positioner>
          <HoverCard.Content ref={ref} {...contentProps}>
            {showArrow && <HoverCard.Arrow />}
            {content}
          </HoverCard.Content>
        </HoverCard.Positioner>
      </Portal>
    </HoverCard.Root>
  );
});

export default Tooltip;
